// apps/web/src/pages/ShelfPage.tsx
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Folder } from 'lucide-react';
import { useLibraryStore } from '../stores/library';
import { ImportButton } from '../components/ImportButton';
import { DocCard } from '../components/DocCard';
import { EmptyState } from '../components/EmptyState';

export function ShelfPage() {
  const { t } = useTranslation();
  const { documents, loading, loadLibrary } = useLibraryStore();
  const [selectedRoute, setSelectedRoute] = useState<string | null>(null);

  useEffect(() => {
    loadLibrary();
  }, [loadLibrary]);

  // 提取所有路线（分组）
  const routes = Array.from(new Set(documents.map((d) => d.route).filter(Boolean))) as string[];

  // 按选中的路线过滤
  const filteredDocs = selectedRoute
    ? documents.filter((d) => d.route === selectedRoute)
    : documents;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-serif text-camel-dark">{t('shelf.title')}</h1>
        <ImportButton />
      </div>

      {/* 路线/分组筛选 (2.4) */}
      {routes.length > 0 && (
        <div className="flex items-center gap-2 mb-4 flex-wrap">
          <Folder className="w-4 h-4 text-charcoal/40" />
          <button
            onClick={() => setSelectedRoute(null)}
            className={`px-3 py-1 rounded-md text-sm transition-colors ${
              selectedRoute === null
                ? 'bg-camel text-white'
                : 'text-charcoal/60 hover:bg-warm-white dark:hover:bg-border-warm-dark'
            }`}
          >
            全部
          </button>
          {routes.map((route) => (
            <button
              key={route}
              onClick={() => setSelectedRoute(route)}
              className={`px-3 py-1 rounded-md text-sm transition-colors ${
                selectedRoute === route
                  ? 'bg-camel text-white'
                  : 'text-charcoal/60 hover:bg-warm-white dark:hover:bg-border-warm-dark'
              }`}
            >
              {route}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <p className="text-charcoal/50">{t('common.loading')}</p>
      ) : filteredDocs.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {filteredDocs.map((doc) => (
            <DocCard key={doc.id} doc={doc} />
          ))}
        </div>
      )}
    </div>
  );
}
